import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var PlansIllustration = function PlansIllustration(_a) {
  var className = _a.className,
    _a$color = _a.color,
    color = _a$color === undefined ? 'sapphire' : _a$color,
    otherProps = __rest(_a, ["className", "color"]);
  return jsxs("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "PlansIllustration",
    role: "img",
    viewBox: "0 0 112 72",
    xmlns: "http://www.w3.org/2000/svg",
    width: "112",
    height: "72",
    fill: "none",
    className: classNames('cogs-illustration', 'cogs-themed-icon', className)
  }, otherProps, {
    children: [jsxs("g", {
      clipPath: "url(#clip0_404_26931)",
      children: [jsx("path", {
        fill: "var(--cogs-decorative--".concat(color, "--400)"),
        d: "m36.464 71.249 34.641-20a4 4 0 0 0 1.464-5.464L50.07 6.814a4 4 0 0 0-5.464-1.464l-34.64 20A4 4 0 0 0 8.5 30.813L31 69.784a4 4 0 0 0 5.464 1.465",
        opacity: ".3"
      }), jsx("path", {
        fill: "#fff",
        d: "m22.722 21.448 12.125-7a3 3 0 1 0-3-5.197l-12.125 7a3 3 0 1 0 3 5.197"
      }), jsx("path", {
        fill: "var(--cogs-decorative--".concat(color, "--400)"),
        d: "m22.722 21.448 12.125-7a3 3 0 1 0-3-5.197l-12.125 7a3 3 0 1 0 3 5.197",
        opacity: ".15"
      }), jsx("path", {
        fill: "var(--cogs-decorative--".concat(color, "--400)"),
        d: "m22.722 21.448 12.125-7a3 3 0 1 0-3-5.197l-12.125 7a3 3 0 1 0 3 5.197",
        opacity: ".05"
      }), jsx("path", {
        fill: "var(--cogs-decorative--".concat(color, "--400)"),
        d: "m40.464 51.249 34.641 20a4 4 0 0 0 5.464-1.464l22.5-38.971a4 4 0 0 0-1.464-5.465l-34.64-20A4 4 0 0 0 61.5 6.815L39 45.784a4 4 0 0 0 1.464 5.465",
        opacity: ".3"
      }), jsx("path", {
        fill: "#fff",
        d: "m76.722 14.448 12.125 7a3 3 0 0 0 3-5.196l-12.125-7a3 3 0 0 0-3 5.196"
      }), jsx("path", {
        fill: "var(--cogs-decorative--".concat(color, "--400)"),
        d: "m76.722 14.448 12.125 7a3 3 0 0 0 3-5.196l-12.125-7a3 3 0 0 0-3 5.196",
        opacity: ".15"
      }), jsx("path", {
        fill: "var(--cogs-decorative--".concat(color, "--400)"),
        d: "m76.722 14.448 12.125 7a3 3 0 0 0 3-5.196l-12.125-7a3 3 0 0 0-3 5.196",
        opacity: ".05"
      }), jsx("path", {
        fill: "#fff",
        d: "M35.785 64h40a4 4 0 0 0 4-4V15a4 4 0 0 0-4-4h-40a4 4 0 0 0-4 4v45a4 4 0 0 0 4 4"
      }), jsx("path", {
        fill: "var(--cogs-decorative--".concat(color, "--400)"),
        d: "M35.785 64h40a4 4 0 0 0 4-4V15a4 4 0 0 0-4-4h-40a4 4 0 0 0-4 4v45a4 4 0 0 0 4 4",
        opacity: ".5"
      }), jsx("path", {
        fill: "#fff",
        d: "M48.785 14h14a3 3 0 0 0 0-6h-14a3 3 0 1 0 0 6"
      }), jsx("path", {
        fill: "var(--cogs-decorative--".concat(color, "--400)"),
        d: "M48.785 14h14a3 3 0 0 0 0-6h-14a3 3 0 1 0 0 6",
        opacity: ".3"
      }), jsx("path", {
        fill: "var(--cogs-decorative--".concat(color, "--400)"),
        d: "M48.785 14h14a3 3 0 0 0 0-6h-14a3 3 0 1 0 0 6",
        opacity: ".4"
      }), jsx("g", {
        fill: "var(--cogs-decorative--".concat(color, "--400)"),
        opacity: ".5",
        children: jsx("path", {
          d: "M71.785 26h-24a2 2 0 1 1 0-4h24a2 2 0 0 1 0 4M71.785 34h-24a2 2 0 1 1 0-4h24a2 2 0 0 1 0 4M47.785 42h24a2 2 0 0 0 0-4h-24a2 2 0 1 0 0 4M55.785 50h-8a2 2 0 1 1 0-4h8a2 2 0 0 1 0 4M37.785 48a2 2 0 1 0 4 0 2 2 0 0 0-4 0M39.785 42a2 2 0 1 1 0-4 2 2 0 0 1 0 4M37.785 32a2 2 0 1 0 4 0 2 2 0 0 0-4 0M39.785 26a2 2 0 1 1 0-4 2 2 0 0 1 0 4"
        })
      })]
    }), jsx("defs", {
      children: jsx("clipPath", {
        id: "clip0_404_26931",
        children: jsx("path", {
          fill: "#fff",
          d: "M0 0h112v72H0z"
        })
      })
    })]
  }));
};

export { PlansIllustration };
